import { gql, TypedDocumentNode } from '@apollo/client';
import { WalletTypeEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { WalletInfoItem } from '@libs/types';
type ChangeDetails = {
  changeDetails?: {
    changeAmount: string;
    changePercentage: string;
  };
};
export type WalletInfo = WalletInfoItem & ChangeDetails;
export type GetWalletInfoResponse = {
  getWalletInfoNew: DefaultApiResponse<WalletInfo[]>;
};

export type GetWalletInfoArgs = {
  assetCode?: string;
  isCrypto?: boolean;
  walletType?: WalletTypeEnum;
  valueAssetCode?: string;
  sortByCmcRank?: boolean;
};
export const getWalletInfo: TypedDocumentNode<
  GetWalletInfoResponse,
  DefaultArg<GetWalletInfoArgs>
> = gql`
  query GetWalletInfoNew($record: GetWalletNewRecord!) {
    getWalletInfoNew(record: $record) {
      amount
      code
      color
      hasNetworks
      iconUrl
      isCrypto
      isDisabled
      isFavorite
      isStable
      name
      networksCount
      orderingPriority
      percentage
      price
      roundingPrecision
      totalValue
      value
    }
  }
`;
